import * as React from 'react';

import { DocumentPreviewOverlay, DocumentPreviewProvider } from '@europrocurement/l2d-modules';
import { FORMALITIES_INVOICES_LIST } from './constants/paths';

import { InvoicesFormalitiesListBack } from './views/list';

export const FacturesRouterBack = {
    path: FORMALITIES_INVOICES_LIST,
    element: (
        <DocumentPreviewProvider>
            <InvoicesFormalitiesListBack />
            <DocumentPreviewOverlay />
        </DocumentPreviewProvider>
    ),
};
